import { DATASET_LNG } from '_legacy/models/Datasets';

const rateTypes = [
    {
        id: 1,
        value: 'FlatRate',
        label: 'Flat rate',
    },
    {
        id: 2,
        value: 'BalticIndex',
        label: 'Baltic index',
    },
];

const lngRateRypes = [
    {
        id: 3,
        value: 'SparkIndex',
        label: 'Spark index',
    },
];
export const flatRateValue = rateTypes[0].value;
export const balticIndexValue = rateTypes[1].value;
export const sparkIndexValue = lngRateRypes[0].value;

const rateTypesByDataset = (datasetId) => {
    switch (datasetId) {
        case DATASET_LNG:
            return [...rateTypes, ...lngRateRypes];
        default:
            return rateTypes;
    }
};

export default rateTypesByDataset;
